import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { apiService } from '../utils/apiRequest';
import { SessionAttendance } from 'tutorapp-components';
import CircularProgress from "@mui/material/CircularProgress";

export default function Sessionattandencescreen() {

  const navigate = useNavigate();
  const sessions = useSelector((state) => state.session);
  const appointmentId = sessions?.appointmentId;
  const selectedFranchise = useSelector((state) => state.franchise?.selectedFranchise);
  const studentids = sessions?.sessionStudent;

  // State declarations
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState();
  const [leavereasons, setLeavereason] = useState('');
  const [attendanceData, setAttendanceData] = useState([]);
  const [absenceReasons, setAbsenceReasons] = useState([]); // Store absence_reason
  const [cancelledNotChargedReasons, setCancelledNotChargedReasons] = useState([]); // Store cancelled_not_charged_reason
  const [studentNames, setStudentNames] = useState([]);
  const [loading, setLoading] = useState(false); // Add loading state
  const [submittedreason, setSubmittedreason] = useState()



  // API call to get absence reasons
 const getAbsenceReason = async (selectedFranchise) => {
    setLoading(true);
    const franchiseId = selectedFranchise.franchise_id;
    const tutorId = selectedFranchise.tutor_id;

    try {
      const getAbsenceReason = process.env.REACT_APP_API_URL + 'getAbsenceReason';
      const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ franchise_id: franchiseId, tutor_id: tutorId }),
      };
      const response = await apiService(getAbsenceReason, options);
      if (response.status === 'success') {
        // Filter absence_reason
        const filteredAbsenceReasons = response.absence_reason.filter((item) => {
          if (item.status === "1") return true;
          if (item.status === "0" && submittedreason?.includes(item.id)) return true;
          return false;
        });
        // Filter cancelled_not_charged_reason
        const filteredCancelledReasons = response.cancelled_not_charged_reason.filter((item) => {
          if (item.status === "1") return true;
          if (item.status === "0" && submittedreason?.includes(item.id)) return true;
          return false;
        });
        setAbsenceReasons(filteredAbsenceReasons);
        setCancelledNotChargedReasons(filteredCancelledReasons);
      } else {
        console.error("Failed to fetch absence reasons:", response.message);
      }
    } catch (error) {
      console.error("Error while fetching absence reasons:", error);
    } finally {
      setLoading(false);
    }
  };
  // API call to get attendance data
  const getAttendanceData = async (appointmentId) => {
    setLoading(true); // Start loading
    try {
      const getAttendanceEndpoint = process.env.REACT_APP_API_URL + 'getAttendanceData';
      const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ appointment_id: appointmentId }),
      };

      const response = await apiService(getAttendanceEndpoint, options);

      if (response.status === 'success') {
        setAttendanceData(response.attendance_data);
        const absenceReasons = attendanceData
          .filter(item => item.absence_reason !== "" )
          .map(item => item.absence_reason);
        setSubmittedreason(absenceReasons)


      } else {
        console.error("Failed to fetch attendance data:", response.message);
        getStudentNames(studentids);

      }
    } catch (error) {
      console.error("Error while fetching attendance data:", error);

    } finally {
      setLoading(false); // Stop loading
    }
  };

  // API call to get student names
  const getStudentNames = async (studentIds) => {
    setLoading(true); // Start loading
    try {
      const endpoint = process.env.REACT_APP_API_URL + 'getStudentName';
      const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ student_ids: studentIds }),
      };

      const response = await apiService(endpoint, options);

      if (response.status === 'success') {
        setStudentNames(response.data);
        const convertedAttendanceData = convertToAttendanceData(response.data.valid_students);
        setAttendanceData(convertedAttendanceData);

      } else {
        toast.error(response.message || "Failed to fetch student names", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "dark",
          style: { backgroundColor: "#D32F2F", color: "#fff", fontWeight: "500" }
        });
      }
    } catch (error) {
      console.error("Error fetching student names:", error);
      toast.error("An error occurred while fetching student names", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "dark",
        style: { backgroundColor: "#D32F2F", color: "#fff", fontWeight: "500" }
      });
    } finally {
      setLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    if (selectedFranchise) {
      getAttendanceData(appointmentId);

      getAbsenceReason(selectedFranchise);
    }
  }, [selectedFranchise]);

  // Save attendance data
  const saveAttendanceData = async (attendancePayload) => {
    setLoading(true); // Start loading
    try {
      const saveAttendanceEndpoint = process.env.REACT_APP_API_URL + 'saveAttendaceData';
      const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(attendancePayload),
      };

      const response = await apiService(saveAttendanceEndpoint, options);

      if (response.status === 'success') {
        toast.success("Attendance saved successfully", {
          position: "top-center",
          autoClose: 4000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          style: { backgroundColor: "#388E3C", color: "#fff", fontWeight: "500" }
        });
        navigate("/session-report")
        return response;
      } else {
        throw new Error(response.message || "Failed to save attendance data");
      }
    } catch (error) {
      console.error("Error while saving attendance data:", error);
      toast.error(error.message || "An error occurred while saving attendance data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "dark",
        style: { backgroundColor: "#D32F2F", color: "#fff", fontWeight: "500" }
      });
      throw error;
    } finally {
      setLoading(false); // Stop loading
    }
  };

  // Handle attendance press
  const handleonattandencePress = (data, safewellcheck, description) => {
    if (!appointmentId) {
      toast.error("No appointment selected", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "dark",
        style: { backgroundColor: "#D32F2F", color: "#fff", fontWeight: "500" }
      });
      return;
    }

    const attendancePayload = {
      appointment_id: appointmentId,
      attendance_data: data,
      safe_well_check_flag: `${safewellcheck}`,
      safe_well_check_reason: description
    };

    saveAttendanceData(attendancePayload)
      .then(response => {
      })
      .catch(error => {
        console.error('Failed to save attendance:', error);
      });

  };

  const onattandencebackPress = () => {
    navigate('/sessiondetails');
  };

 
  const toggleModalVisibility = () => {

    setModalVisible(prevState => !prevState);

  };

  const getStudentLeaveData = (data) => {
    setSelectedStudent(data)
  }


  // Convert student data to attendance format
  const convertToAttendanceData = (validStudentsObj) => {
    return Object.entries(validStudentsObj).map(([student_id, student_name]) => ({
      student_id,
      student_name,
      is_present: null,
      absence_reason: {}
    }));
  };

  return (
    <div style={{ position: 'relative' }}>
      {/* Show CircularProgress when loading */}
      {loading && (
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1000
        }}>
          <CircularProgress style={{ color: 'black' }} />
        </div>
      )}
      <SessionAttendance
        data={attendanceData?.length > 0 ? attendanceData : null}
        icons={{
          sessionappointment: "./images/ic_sessionappointment.svg",
          close: "./images/ic_close.svg",
          progress: "./images/ic_one.svg",
          chatnew: "./images/Chat_New.svg",
          chat: "./images/Chat.svg"
        }}
        onattandencePress={handleonattandencePress}
        toggleModalVisibility={toggleModalVisibility}
        attendees={attendanceData}
        onattandencebackPress={onattandencebackPress}
        getStudentLeaveData={getStudentLeaveData}
        absenceReasons={absenceReasons} // Pass absence reasons
        cancelledNotChargedReasons={cancelledNotChargedReasons} // Pass cancelled not charged reasons
        leaveReasons={leavereasons}
        selectedStudent={selectedStudent}
      />
     
      <ToastContainer />
    </div>
  );
}